// Root-context helpers for extraction scanner control flow.
// Example: splitRootInlineLine(":root { --x: 1; }").

// Regex detects a standalone `:root` selector token in a line.
const rootSelectorRegex = /(^|[^a-zA-Z0-9_-]):root\b/

// Detect whether text starts with a variable declaration token.
export function startsVariableDeclaration(text: string): boolean {
  // Return true when trimmed text starts with `--`.
  return text.trimStart().startsWith('--')
}

// Check if remainder contains only structural braces and whitespace.
export function isStructuralRemainder(text: string): boolean {
  // Return true for structural-only trailing fragments.
  return /^[}\s]*$/.test(text)
}

// Detect top-level inline `:root { ...` openers.
export function isRootInlineStart(trimmedLine: string, depth: number, insideRootBlock: boolean): boolean {
  // Skip detection when parser is already inside a root block.
  if (insideRootBlock) {
    return false
  } else if (depth !== 0) {
    // Skip detection when current structural depth is not top-level.
    return false
  } else {
    // Return true when top-level :root inline opener is detected.
    return rootSelectorRegex.test(trimmedLine) && trimmedLine.includes('{')
  }
}

// Split one `:root { ...` line into structural prefix and inline content.
export function splitRootInlineLine(line: string): { prefix: string; inline: string } {
  const braceIndex = line.indexOf('{')
  // Fallback when line unexpectedly has no opening brace.
  if (braceIndex === -1) {
    return { prefix: line, inline: '' }
  } else {
    // Return root prefix and inline value fragments.
    return {
      prefix: line.slice(0, braceIndex + 1),
      inline: line.slice(braceIndex + 1),
    }
  }
}

// Detect root-block start from one preserved structural line.
export function startsRootBlockLine(trimmedText: string, depth: number, insideRootBlock: boolean, openCount: number): boolean {
  // Return true when parser enters top-level :root block.
  return !insideRootBlock && depth === 0 && rootSelectorRegex.test(trimmedText) && openCount > 0
}
